export default "__VITE_ASSET__Be7XLE65__"